import script from "./WithdrawPreviewModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawPreviewModal.vue?vue&type=script&setup=true&lang=ts"

export default script